/* global jQuery */

($ => {
    $(() => {
        // $('.js-filter-tr-components').off();
        const targetClass =
            ".structurefilter__top";
        const componentClass = ".structure__details";

        const filterComponents = ({ items, selectedFilters }) => {
            if (!items.length) {
                return;
            }
            // Show all if no filters selected.
            if (!Object.keys(selectedFilters).length) {
                items.forEach(({ $element }) => {
                    $element.slideDown();
                });
                return;
            }

            const filterEntries = Object.entries(selectedFilters);
            items.forEach(({ $element, meta }) => {
                if (
                    // At least one from each selected meta's values must hit.
                    filterEntries.every(
                        ([filterName, filterValues]) =>
                            Object.hasOwnProperty.call(meta, filterName) &&
                            filterValues.some(filterValue =>
                                meta[filterName].includes(filterValue)
                            )
                    )
                ) {
                    $element.slideDown();
                } else {
                    $element.slideUp();
                }
            });
        };

        const items = [];
        $(targetClass).each((_, t) => {
            const $target = $(t);
            const meta = {};
            $target.find(`${componentClass} [data-meta-name]`).each((_, el) => {
                const { metaName, metaValue } = $(el).data();
                if (!Object.hasOwnProperty.call(meta, metaName)) {
                    meta[metaName] = [];
                }
                meta[metaName].push(metaValue);
            });

            const newItem = {
                $element: $target,
                meta
            };
            items.push(newItem);
        });

        const selectedFilters = {};


        function countActiveItems(index) {
            // var numItems = [];
            // numItems.push(value);
            // console.log(numItems);

            const activeAmount = $('.is-active', index).length;
            console.log(activeAmount);
            if (activeAmount > 0) {
                $('.amount', index).css("display", "inline-block");
                $('.amount', index).html(activeAmount);
            } else {
                $('.amount', index).css("display", "none");
            }


        }


        $(".dropdown-content li").on("click", function clickFilter() {
            const $this = $(this);

            const { metaName, metaValue } = $this.data();
            if (!Object.hasOwnProperty.call(selectedFilters, metaName)) {
                selectedFilters[metaName] = [];
            }

            // We can choose multiple component types for filtering.
            const removeIdx = selectedFilters[metaName].indexOf(metaValue);

            if (!$this.siblings('li').hasClass('is-active')) {
                $this.parent($('.dropdown-content')).siblings('button').removeClass('active');
            }

            if (removeIdx !== -1) {
                $this.removeClass("is-active");


                selectedFilters[metaName].splice(removeIdx, 1);
                if (!selectedFilters[metaName].length) {
                    delete selectedFilters[metaName];
                }
            } else {
                $this.parent($('.dropdown-content')).siblings('button').addClass('active');
                // $('.dropbtn').addClass('active');
                $this.addClass("is-active");

                selectedFilters[metaName].push(metaValue);
            }
            countActiveItems($this.closest($('.filter-dropdown')));
            filterComponents({ items, selectedFilters });
            // filterComponents({ items, selectedFilters });
        });
    });
})(jQuery);
